// extracted by mini-css-extract-plugin
export var container = "_lw-0";
export var dotAnimation = "_lw-2";
export var dotsLoading = "_lw-1";